import { MEDIA_QUERIES as M } from '../../../foundations/grid';
import S from '../../../foundations/size';
import { ColorCodes } from '../../../foundations';
import { genThemedStyled } from '../../../utilities/theme';
import { FUTURO_TYPEFACES as F } from '../../../foundations/font';

type themeStyles = {
  textColor: ColorCodes;
  footerTextColor: ColorCodes;
};

const ThemeStyled = genThemedStyled<themeStyles>();

export const SignedInContainer = ThemeStyled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  a: {
    margin: `-${S.XXXS} 0 0 -${S.S}`,
  },
  [M.TABLET_PORTRAIT_AND_SMALLER]: {
    marginTop: S.S,
    alignItems: 'center',
    a: {
      marginLeft: 0,
    },
  },
});

export const SignedInAs = ThemeStyled.p(
  p => ({
    color: p.theme.textColor,
    margin: 0,
    padding: 0,
  }),
  F.BODY_SMALL
);

export const ButtonWrapper = ThemeStyled.div({
  marginLeft: 'auto',
  button: {
    minWidth: '8.5rem',
  },
  [M.TABLET_PORTRAIT_AND_SMALLER]: {
    width: '100%',
    marginBottom: S.S,
    button: {
      width: '100%',
    },
  },
});

export const SignedOutContainer = ThemeStyled.div(
  div => ({
    color: div.theme.footerTextColor,
    margin: 0,
    padding: 0,
    a: {
      padding: 0,
      width: 'auto',
    },
  }),
  F.BODY
);
